<template>
  <div class="track-trace-results">
    <router-view v-if="results && !loading"></router-view>
    <Loading v-if="!loading && !allSystemsReturned" />
  </div>
</template>

<script>
// @ is an alias to /src
import { actions, mutations, store } from '@/store'
import { cleanUrlParam, dirtyUrlParam} from '@/utils'
import Loading from '@/components/Loading'

export default {
  name: 'Results',
  components: {
    Loading
  },
  methods: {
    doSearch() {
      if (this.$route.params.trackingNumber) {
        actions.getSearchResults(dirtyUrlParam(this.$route.params.trackingNumber))        
      } else {
        mutations.setResults([])
      }
    },

    maybeRedirect () {
      if (this.allSystemsReturned && Array.isArray(this.results) && this.results.length === 1) {
        const path = `/s/${cleanUrlParam(this.$route.params.trackingNumber)}/d/${cleanUrlParam(this.results[0].details.uniqueId)}`
        if (this.$route.path !== path) {
          this.$router.push({path: path})
        }              
      }
    }
  },
  computed: {
    results () {
      return store.results
    },
    loading () {
      return store.loading
    },
    allSystemsReturned () {
      return store.allSystemsReturned
    }
  },
  mounted () {
    this.doSearch()
  },
  watch: {
    '$route.params.trackingNumber'() {
      this.doSearch()
    },
    '$route.query.key'() {
      this.doSearch()
    },
    'allSystemsReturned' (val) {
      if (val) {
        this.maybeRedirect()
      }
    }
  }
}
</script>
